import React, { useEffect } from 'react';
import BrightbackSession from '@bbkAdminUtils/brightback-session';
import { SuspenseLoader } from '@bbkAdminComponents/loaders/suspense-loader';
import { LogInPaths } from '@bbkAdminComponents/log-in-flow/log-in-paths';

export const LogoutPage: React.FC = () => {
  useEffect(() => {
    BrightbackSession.clear();
    window.location.assign(LogInPaths.signIn);
  }, []);

  return <SuspenseLoader />;
};
